// extracted by mini-css-extract-plugin
export default {"tagContainer":"YXXOZ2UoUzLeYpz925hp","tagNew":"ykvPQ6ZVDbgHAVxskJl2"};